var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('ul',_vm._l((_vm.footerList),function(item,index){return _c('li',{key:index},[_c('router-link',{attrs:{"to":item.url}},[_c('div',{staticClass:"icon-wrap"},[(item.count && item.count > 0)?_c('span',[_vm._v(_vm._s(item.count))]):_vm._e(),_vm._v(" "),_c('img',{attrs:{"src":item.imgSrc}})])])],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e98c206","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FooterNav.vue
// module id = null
// module chunks = 